module.exports = __webpack_public_path__ + "img/8.12cf4d06.jpg";